<div [ngClass]="{ 'dark text-white-dark': store.semidark }">
  <nav
    class="sidebar fixed top-0 bottom-0 z-[51] h-full min-h-screen w-[16rem] transition-all duration-300"
    (mouseleave)="onSidebarMouseLeave($event)"
  >
    <div class="h-full bg-card flex flex-col">
      <div
        class="sidebar-brand-row relative z-[70] flex shrink-0 items-center gap-0 px-4 py-3"
      >
        <app-workspace-switcher />
        <a
          href="javascript:;"
          class="collapse-icon ml-1 flex h-8 w-8 shrink-0 items-center rounded-full transition duration-300 hover:bg-gray-500/10 hover:text-primary rtl:rotate-180 dark:text-white-light dark:hover:bg-dark-light/10"
          (click)="onCollapseSidebar()"
        >
          <svg
            class="m-auto h-5 w-5"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13 19L7 12L13 5"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              opacity="0.5"
              d="M16.9998 19L10.9998 12L16.9998 5"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </a>
      </div>
      <div class="flex min-h-0 flex-1 flex-col overflow-hidden">
        <ng-scrollbar
          class="relative !h-[calc(100vh-180px)]"
          appearance="compact"
        >
          <ul class="relative space-y-0.5 2xl:p-3 p-4 py-0 font-normal">
            @if (isAdminOrManager) {
            <li class="accordion menu nav-item">
              <button
                type="button"
                class="nav-link group w-full"
                [ngClass]="{ active: activeDropdown.includes('dashboards') }"
                (click)="toggleAccordion('dashboards')"
              >
                <div class="flex items-center">
                  <icon-menu-dashboard
                    class="shrink-0 group-hover:!text-primary"
                  />
                  <span
                    class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark"
                  >
                    {{ 'Dashboards' | translate }}
                  </span>
                </div>
                <div
                  [ngClass]="{ 'rtl:rotate-90 -rotate-90': !activeDropdown.includes('dashboards') }"
                >
                  <icon-caret-down />
                </div>
              </button>
              <div
                [@slideDownUp]="!activeDropdown.includes('dashboards')"
                class="accordion-content text-xs"
              >
                <ul class="sub-menu text-gray-500">
                  <li>
                    <a
                      routerLink="/dashboard"
                      routerLinkActive="active"
                      [routerLinkActiveOptions]="{ exact: true }"
                      (click)="toggleMobileMenu()"
                    >
                      {{ 'Default Dashboard' | translate }}
                    </a>
                  </li>
                  @if (showCustomDashboardNav) {
                  @if (!isNavFeatureLocked('Data & Reports:crm-dashboards')) {
                  @for (dash of customDashboards(); track dash.id) {
                  <li>
                    <a
                      [routerLink]="['/dashboards', dash.id]"
                      routerLinkActive="active"
                      (click)="toggleMobileMenu()"
                    >
                      {{ dash.name }}
                    </a>
                  </li>
                  }
                  }
                  <li>
                    <a
                      href="javascript:;"
                      (click)="openCreateDashboardDialog(); toggleMobileMenu()"
                    >
                      <span
                        class="flex w-full items-center justify-between gap-1.5"
                      >
                        {{ 'Create dashboard' | translate }} @if
                        (isNavFeatureLocked('Data & Reports:crm-dashboards')) {
                        <icon-lock
                          class="h-3.5 w-3.5 shrink-0"
                          aria-hidden="true"
                        />
                        }
                      </span>
                    </a>
                  </li>
                  }
                </ul>
              </div>
            </li>
            } @else {
            <li class="nav-item">
              <a
                routerLink="/dashboard"
                class="group"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
                (click)="toggleMobileMenu()"
              >
                <div class="flex items-center">
                  <icon-menu-dashboard
                    class="shrink-0 group-hover:!text-primary"
                  />
                  <span
                    class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark"
                  >
                    {{ 'Dashboard' | translate }}
                  </span>
                </div>
              </a>
            </li>
            }

            <li class="accordion menu nav-item">
              <button
                type="button"
                class="nav-link group w-full"
                [ngClass]="{ active: activeDropdown.includes('project-management') }"
                (click)="toggleAccordion('project-management')"
              >
                <div class="flex items-center">
                  <icon-menu-components
                    class="shrink-0 group-hover:!text-primary"
                  />

                  <span
                    class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark"
                  >
                    {{ 'CRM' | translate }}
                  </span>
                </div>
                <div
                  [ngClass]="{ 'rtl:rotate-90 -rotate-90': !activeDropdown.includes('project-management') }"
                >
                  <icon-caret-down />
                </div>
              </button>
              <div
                [@slideDownUp]="!activeDropdown.includes('project-management')"
                class="accordion-content text-xs"
              >
                <ul class="sub-menu text-gray-500">
                  <li>
                    <a
                      routerLink="/crm/people"
                      routerLinkActive="active"
                      [routerLinkActiveOptions]="{exact: true}"
                      (click)="toggleMobileMenu()"
                    >
                      <span
                        class="flex w-full items-center justify-between gap-1.5"
                      >
                        {{ 'People' | translate }} @if
                        (isNavFeatureLocked('CRM:people')) {
                        <icon-lock
                          class="h-3.5 w-3.5 shrink-0"
                          aria-hidden="true"
                        />
                        }
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      routerLink="/crm/companies"
                      routerLinkActive="active"
                      [routerLinkActiveOptions]="{exact: true}"
                      (click)="toggleMobileMenu()"
                    >
                      <span
                        class="flex w-full items-center justify-between gap-1.5"
                      >
                        {{ 'Companies ' | translate }} @if
                        (isNavFeatureLocked('CRM:companies')) {
                        <icon-lock
                          class="h-3.5 w-3.5 shrink-0"
                          aria-hidden="true"
                        />
                        }
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      routerLink="/crm/leads"
                      routerLinkActive="active"
                      [routerLinkActiveOptions]="{exact: true}"
                      (click)="toggleMobileMenu()"
                    >
                      <span
                        class="flex w-full items-center justify-between gap-1.5"
                      >
                        {{ 'Leads' | translate }} @if
                        (isNavFeatureLocked('CRM:leads')) {
                        <icon-lock
                          class="h-3.5 w-3.5 shrink-0"
                          aria-hidden="true"
                        />
                        }
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      routerLink="/crm/deals"
                      routerLinkActive="active"
                      [routerLinkActiveOptions]="{exact: true}"
                      (click)="toggleMobileMenu()"
                    >
                      <span
                        class="flex w-full items-center justify-between gap-1.5"
                      >
                        {{ 'Deals' | translate }} @if
                        (isNavFeatureLocked('CRM:deals')) {
                        <icon-lock
                          class="h-3.5 w-3.5 shrink-0"
                          aria-hidden="true"
                        />
                        }
                      </span>
                    </a>
                  </li>
                  @if (referenceVerificationEnabled) {
                  <li>
                    <a
                      routerLink="/crm/references"
                      routerLinkActive="active"
                      [routerLinkActiveOptions]="{exact: false}"
                      (click)="toggleMobileMenu()"
                    >
                      <span
                        class="flex w-full items-center justify-between gap-1.5"
                      >
                        {{ 'Reference Verification' | translate }}
                      </span>
                    </a>
                  </li>
                  }
                </ul>
              </div>
            </li>

            <li class="accordion menu nav-item">
              <button
                type="button"
                id="activities-nav-toggle"
                class="nav-link group w-full"
                [ngClass]="{ active: activeDropdown.includes('activities') }"
                (click)="toggleAccordion('activities')"
              >
                <div class="flex items-center">
                  <icon-menu-notes class="shrink-0 group-hover:!text-primary" />

                  <span
                    class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark"
                  >
                    {{ 'Activities' | translate }}
                  </span>
                </div>
                <div
                  [ngClass]="{ 'rtl:rotate-90 -rotate-90': !activeDropdown.includes('activities') }"
                >
                  <icon-caret-down />
                </div>
              </button>
              <div
                [@slideDownUp]="!activeDropdown.includes('activities')"
                class="accordion-content text-xs"
              >
                <ul class="sub-menu text-gray-500">
                  <li>
                    <a
                      id="activities-nav-tasks"
                      routerLink="/activities/tasks"
                      routerLinkActive="active"
                      [routerLinkActiveOptions]="{ exact: false }"
                      (click)="toggleMobileMenu()"
                    >
                      <span
                        class="flex w-full items-center justify-between gap-1.5"
                      >
                        {{ 'Tasks' | translate }} @if
                        (isNavFeatureLocked('Activities:tasks')) {
                        <icon-lock
                          class="h-3.5 w-3.5 shrink-0"
                          aria-hidden="true"
                        />
                        }
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      id="activities-nav-calendar"
                      routerLink="/activities/calendar"
                      routerLinkActive="active"
                      [routerLinkActiveOptions]="{ exact: true }"
                      (click)="toggleMobileMenu()"
                    >
                      <span
                        class="flex w-full items-center justify-between gap-1.5"
                      >
                        {{ 'Calendar' | translate }} @if
                        (isNavFeatureLocked('Activities:calendar')) {
                        <icon-lock
                          class="h-3.5 w-3.5 shrink-0"
                          aria-hidden="true"
                        />
                        }
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      id="activities-nav-notes"
                      routerLink="/activities/notes"
                      routerLinkActive="active"
                      [routerLinkActiveOptions]="{ exact: true }"
                      (click)="toggleMobileMenu()"
                    >
                      <span
                        class="flex w-full items-center justify-between gap-1.5"
                      >
                        {{ 'Notes' | translate }} @if
                        (isNavFeatureLocked('Activities:notes')) {
                        <icon-lock
                          class="h-3.5 w-3.5 shrink-0"
                          aria-hidden="true"
                        />
                        }
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      id="activities-nav-drive"
                      routerLink="/activities/drive"
                      routerLinkActive="active"
                      [routerLinkActiveOptions]="{ exact: true }"
                      (click)="toggleMobileMenu()"
                    >
                      <span
                        class="flex w-full items-center justify-between gap-1.5"
                      >
                        {{ 'Drive' | translate }} @if
                        (isNavFeatureLocked('Activities:drive')) {
                        <icon-lock
                          class="h-3.5 w-3.5 shrink-0"
                          aria-hidden="true"
                        />
                        }
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      id="activities-nav-list"
                      routerLink="/activities/list"
                      routerLinkActive="active"
                      [routerLinkActiveOptions]="{ exact: false }"
                      (click)="toggleMobileMenu()"
                    >
                      <span
                        class="flex w-full items-center justify-between gap-1.5"
                      >
                        {{ 'List' | translate }} @if
                        (isNavFeatureLocked('Activities:list-view')) {
                        <icon-lock
                          class="h-3.5 w-3.5 shrink-0"
                          aria-hidden="true"
                        />
                        }
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      id="activities-nav-inbox"
                      routerLink="/activities/inbox"
                      routerLinkActive="active"
                      [routerLinkActiveOptions]="{ exact: true }"
                      (click)="toggleMobileMenu()"
                    >
                      <span
                        class="flex w-full items-center justify-between gap-1.5"
                      >
                        {{ 'Inbox' | translate }} @if
                        (isNavFeatureLocked('Activities:inbox')) {
                        <icon-lock
                          class="h-3.5 w-3.5 shrink-0"
                          aria-hidden="true"
                        />
                        }
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      id="activities-nav-calls"
                      routerLink="/activities/calls"
                      routerLinkActive="active"
                      [routerLinkActiveOptions]="{ exact: true }"
                      (click)="toggleMobileMenu()"
                    >
                      <span
                        class="flex w-full items-center justify-between gap-1.5"
                      >
                        {{ 'Calls' | translate }} @if
                        (isNavFeatureLocked('Activities:calls')) {
                        <icon-lock
                          class="h-3.5 w-3.5 shrink-0"
                          aria-hidden="true"
                        />
                        }
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      id="whatsapp-nav-link"
                      routerLink="/whatsapp"
                      routerLinkActive="active"
                      [routerLinkActiveOptions]="{ exact: true }"
                      (click)="toggleMobileMenu()"
                    >
                      <span
                        class="flex w-full items-center justify-between gap-1.5"
                      >
                        {{ 'WhatsApp' | translate }} @if
                        (isNavFeatureLocked('Communication:whatsapp')) {
                        <icon-lock
                          class="h-3.5 w-3.5 shrink-0"
                          aria-hidden="true"
                        />
                        }
                      </span>
                    </a>
                  </li>
                </ul>
              </div>
            </li>

            <li class="accordion menu nav-item">
              <button
                type="button"
                class="nav-link group w-full"
                [ngClass]="{ active: activeDropdown.includes('marketing') }"
                (click)="toggleAccordion('marketing')"
              >
                <div class="flex items-center">
                  <icon-menu-charts
                    class="shrink-0 group-hover:!text-primary"
                  />

                  <span
                    class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark"
                  >
                    {{ 'Marketing' | translate }}
                  </span>
                </div>
                <div
                  [ngClass]="{ 'rtl:rotate-90 -rotate-90': !activeDropdown.includes('marketing') }"
                >
                  <icon-caret-down />
                </div>
              </button>
              <div
                [@slideDownUp]="!activeDropdown.includes('marketing')"
                class="accordion-content text-xs"
              >
                <ul class="sub-menu text-gray-500">
                  <li>
                    <a
                      routerLink="/marketing/campaigns"
                      routerLinkActive="active"
                      [routerLinkActiveOptions]="{ exact: false }"
                      (click)="toggleMobileMenu()"
                    >
                      <span
                        class="flex w-full items-center justify-between gap-1.5"
                      >
                        {{ 'Campaigns' | translate }} @if
                        (isNavFeatureLocked('Marketing:campaigns')) {
                        <icon-lock
                          class="h-3.5 w-3.5 shrink-0"
                          aria-hidden="true"
                        />
                        }
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      routerLink="/marketing/templates"
                      routerLinkActive="active"
                      [routerLinkActiveOptions]="{ exact: true }"
                      (click)="toggleMobileMenu()"
                    >
                      <span
                        class="flex w-full items-center justify-between gap-1.5"
                      >
                        {{ 'Templates' | translate }} @if
                        (isNavFeatureLocked('Marketing:templates')) {
                        <icon-lock
                          class="h-3.5 w-3.5 shrink-0"
                          aria-hidden="true"
                        />
                        }
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      routerLink="/marketing/social-hub"
                      routerLinkActive="active"
                      [routerLinkActiveOptions]="{ exact: false }"
                      (click)="toggleMobileMenu()"
                    >
                      <span
                        class="flex w-full items-center justify-between gap-1.5"
                      >
                        {{ 'Social hub' | translate }} @if
                        (isNavFeatureLocked('Marketing:social-hub')) {
                        <icon-lock
                          class="h-3.5 w-3.5 shrink-0"
                          aria-hidden="true"
                        />
                        }
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      routerLink="/marketing/meta-ads"
                      routerLinkActive="active"
                      [routerLinkActiveOptions]="{ exact: false }"
                      (click)="toggleMobileMenu()"
                    >
                      <span
                        class="flex w-full items-center justify-between gap-1.5"
                      >
                        {{ 'Meta Ads' | translate }} @if
                        (isNavFeatureLocked('Marketing:social-hub')) {
                        <icon-lock
                          class="h-3.5 w-3.5 shrink-0"
                          aria-hidden="true"
                        />
                        }
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      routerLink="/marketing/forms"
                      routerLinkActive="active"
                      [routerLinkActiveOptions]="{ exact: false }"
                      (click)="toggleMobileMenu()"
                    >
                      <span
                        class="flex w-full items-center justify-between gap-1.5"
                      >
                        {{ 'Forms' | translate }} @if
                        (isNavFeatureLocked('Marketing:forms')) {
                        <icon-lock
                          class="h-3.5 w-3.5 shrink-0"
                          aria-hidden="true"
                        />
                        }
                      </span>
                    </a>
                  </li>
                </ul>
              </div>
            </li>

            <li class="accordion menu nav-item">
              <button
                type="button"
                class="nav-link group w-full"
                [ngClass]="{ active: activeDropdown.includes('reporting') }"
                (click)="toggleAccordion('reporting')"
              >
                <div class="flex items-center">
                  <icon-menu-tables
                    class="shrink-0 group-hover:!text-primary"
                  />

                  <span
                    class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark"
                  >
                    {{ 'Reporting' | translate }}
                  </span>
                </div>
                <div
                  [ngClass]="{ 'rtl:rotate-90 -rotate-90': !activeDropdown.includes('reporting') }"
                >
                  <icon-caret-down />
                </div>
              </button>
              <div
                [@slideDownUp]="!activeDropdown.includes('reporting')"
                class="accordion-content text-xs"
              >
                <ul class="sub-menu text-gray-500">
                  <li>
                    <a
                      routerLink="/reporting/all"
                      routerLinkActive="active"
                      [routerLinkActiveOptions]="{ exact: true }"
                      (click)="toggleMobileMenu()"
                    >
                      <span
                        class="flex w-full items-center justify-between gap-1.5"
                      >
                        {{ 'Reports' | translate }} @if
                        (isNavFeatureLocked('Data & Reports:crm-reports')) {
                        <icon-lock
                          class="h-3.5 w-3.5 shrink-0"
                          aria-hidden="true"
                        />
                        }
                      </span>
                    </a>
                  </li>
                </ul>
              </div>
            </li>

            <li class="accordion menu nav-item">
              <button
                type="button"
                class="nav-link group w-full"
                [ngClass]="{ active: activeDropdown.includes('pre-sales') }"
                (click)="toggleAccordion('pre-sale')"
              >
                <div class="flex items-center">
                  <icon-menu-notes class="shrink-0 group-hover:!text-primary" />

                  <span
                    class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark"
                  >
                    {{ 'Automation' | translate }}
                  </span>
                </div>
                <div
                  [ngClass]="{ 'rtl:rotate-90 -rotate-90': !activeDropdown.includes('pre-sale') }"
                >
                  <icon-caret-down />
                </div>
              </button>
              <div
                [@slideDownUp]="!activeDropdown.includes('pre-sale')"
                class="accordion-content text-xs"
              >
                <ul class="sub-menu text-gray-500">
                  <li>
                    <a
                      routerLink="/workflows"
                      routerLinkActive="active"
                      [routerLinkActiveOptions]="{exact: true}"
                      (click)="toggleMobileMenu()"
                    >
                      <span
                        class="flex w-full items-center justify-between gap-1.5"
                      >
                        {{ 'Workflows' | translate }} @if
                        (isNavFeatureLocked('Automation:workflows')) {
                        <icon-lock
                          class="h-3.5 w-3.5 shrink-0"
                          aria-hidden="true"
                        />
                        }
                      </span>
                    </a>
                  </li>
                </ul>
              </div>
            </li>

            <li class="accordion menu nav-item">
              <button
                type="button"
                class="nav-link group w-full"
                [ngClass]="{ active: activeDropdown.includes('ai-studio') }"
                (click)="toggleAccordion('ai-studio')"
              >
                <div class="flex items-center">
                  <icon-cpu-bolt class="shrink-0 group-hover:!text-primary" />

                  <span
                    class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark"
                  >
                    {{ 'AI Studio' | translate }}
                  </span>
                </div>
                <div
                  [ngClass]="{ 'rtl:rotate-90 -rotate-90': !activeDropdown.includes('ai-studio') }"
                >
                  <icon-caret-down />
                </div>
              </button>
              <div
                [@slideDownUp]="!activeDropdown.includes('ai-studio')"
                class="accordion-content text-xs"
              >
                <ul class="sub-menu text-gray-500">
                  <li>
                    <a
                      routerLink="/ai-studio/cluster-model"
                      routerLinkActive="active"
                      [routerLinkActiveOptions]="{ exact: true }"
                      (click)="toggleMobileMenu()"
                      >{{ 'Cluster Model' | translate }}</a
                    >
                  </li>
                  <li>
                    <a
                      routerLink="/ai-studio/segment"
                      routerLinkActive="active"
                      [routerLinkActiveOptions]="{ exact: true }"
                      (click)="toggleMobileMenu()"
                      >{{ 'Segment' | translate }}</a
                    >
                  </li>
                  <li>
                    <a
                      routerLink="/ai-studio/lead-scoring-engine"
                      routerLinkActive="active"
                      [routerLinkActiveOptions]="{ exact: true }"
                      (click)="toggleMobileMenu()"
                      >{{ 'Lead Scoring Engine' | translate }}</a
                    >
                  </li>
                </ul>
              </div>
            </li>

            <!--<li class="accordion menu nav-item">
                        <button
                            type="button"
                            class="nav-link group w-full"
                            [ngClass]="{ active: activeDropdown.includes('property-bookings') }"
                            (click)="toggleAccordion('property-bookings')"
                        >
                            <div class="flex items-center">
                                <icon-menu-contacts class="shrink-0 group-hover:!text-primary" />

                                <span class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark">
                                    {{ 'Property Bookings' | translate }}
                                </span>
                            </div>
                            <div [ngClass]="{ 'rtl:rotate-90 -rotate-90': !activeDropdown.includes('property-bookings') }">
                                <icon-caret-down />
                            </div>
                        </button>
                        <div [@slideDownUp]="!activeDropdown.includes('property-bookings')" class="accordion-content text-xs">
                            <ul class="sub-menu text-gray-500">
                                <li>
                                    <a routerLink="/bh-bookings" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" (click)="toggleMobileMenu()">{{ 'Bookings' | translate }}</a>
                                </li>
                                <li>
                                    <a routerLink="/bh-loans" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"  (click)="toggleMobileMenu()">{{ 'Loans' | translate }}</a>
                                </li>
                                <li>
                                    <a routerLink="/bh-property-registration" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"  (click)="toggleMobileMenu()">{{ 'Property Registration' | translate }}</a>
                                </li>
                                <li>
                                    <a routerLink="/bh-demand-payments" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"  (click)="toggleMobileMenu()">{{ 'Demand & Payments' | translate }}</a>
                                </li>
                                <li>
                                    <a routerLink="/bh-documents" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"  (click)="toggleMobileMenu()">{{ 'Documents' | translate }}</a>
                                </li>
                            </ul>
                        </div>
                    </li>

                    <li class="accordion menu nav-item">
                        <button
                            type="button"
                            class="nav-link group w-full"
                            [ngClass]="{ active: activeDropdown.includes('post-sales-activities') }"
                            (click)="toggleAccordion('post-sales-activities')"
                        >
                            <div class="flex items-center">
                                <icon-menu-forms class="shrink-0 group-hover:!text-primary" />

                                <span class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark">
                                    {{ 'Post Sales Activities' | translate }}
                                </span>
                            </div>
                            <div [ngClass]="{ 'rtl:rotate-90 -rotate-90': !activeDropdown.includes('post-sales-activities') }">
                                <icon-caret-down />
                            </div>
                        </button>
                        <div [@slideDownUp]="!activeDropdown.includes('post-sales-activities')" class="accordion-content text-xs">
                            <ul class="sub-menu text-gray-500">
                                <li>
                                    <a routerLink="/bh-quality-inspection" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" (click)="toggleMobileMenu()">{{ 'Quality Inspection' | translate }}</a>
                                </li>
                                <li>
                                    <a routerLink="/bh-project-completion" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"  (click)="toggleMobileMenu()">{{ 'Project Completion' | translate }}</a>
                                </li>
                                <li>
                                    <a routerLink="/bh-key-handover" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"  (click)="toggleMobileMenu()">{{ 'Key Handover' | translate }}</a>
                                </li>
                                <li>
                                    <a routerLink="/bh-customer-tickets" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"  (click)="toggleMobileMenu()">{{ 'Customer Tickets' | translate }}</a>
                                </li>
                            </ul>
                        </div>
                    </li>

                    <li class="accordion menu nav-item">
                        <button
                            type="button"
                            class="nav-link group w-full"
                            [ngClass]="{ active: activeDropdown.includes('system-management') }"
                            (click)="toggleAccordion('system-management')"
                        >
                            <div class="flex items-center">
                                <icon-menu-authentication class="shrink-0 group-hover:!text-primary" />

                                <span class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark">
                                    {{ 'System Management' | translate }}
                                </span>
                            </div>
                            <div [ngClass]="{ 'rtl:rotate-90 -rotate-90': !activeDropdown.includes('system-management') }">
                                <icon-caret-down />
                            </div>
                        </button>
                        <div [@slideDownUp]="!activeDropdown.includes('system-management')" class="accordion-content text-xs">
                            <ul class="sub-menu text-gray-500">
                                <li>
                                    <a routerLink="/bh-companies" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" (click)="toggleMobileMenu()">{{ 'Companies' | translate }}</a>
                                </li>
                                <li>
                                    <a routerLink="/bh-audit-logs" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"  (click)="toggleMobileMenu()">{{ 'Audit Logs' | translate }}</a>
                                </li>
                                <li>
                                    <a routerLink="/bh-recycle-bin" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"  (click)="toggleMobileMenu()">{{ 'Recycle Bin' | translate }}</a>
                                </li>
                                <li>
                                    <a routerLink="/bh-ui-customization" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"  (click)="toggleMobileMenu()">{{ 'UI Customization' | translate }}</a>
                                </li>
                            </ul>
                        </div>
                    </li>

                    <li class="accordion menu nav-item">
                        <button
                            type="button"
                            class="nav-link group w-full"
                            [ngClass]="{ active: activeDropdown.includes('price-management') }"
                            (click)="toggleAccordion('price-management')"
                        >
                            <div class="flex items-center">
                                <icon-dollar-sign-circle [fill]="true" class="shrink-0 group-hover:!text-primary" />

                                <span class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark">
                                    {{ 'Price Management' | translate }}
                                </span>
                            </div>
                            <div [ngClass]="{ 'rtl:rotate-90 -rotate-90': !activeDropdown.includes('price-management') }">
                                <icon-caret-down />
                            </div>
                        </button>
                        <div [@slideDownUp]="!activeDropdown.includes('price-management')" class="accordion-content text-xs">
                            <ul class="sub-menu text-gray-500">
                                <li>
                                    <a routerLink="/bh-base-rate-master" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" (click)="toggleMobileMenu()">{{ 'Base Rate Master' | translate }}</a>
                                </li>
                                <li>
                                    <a routerLink="/bh-floor-rise-master" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"  (click)="toggleMobileMenu()">{{ 'Floor Rise Master' | translate }}</a>
                                </li>
                                <li>
                                    <a routerLink="/bh-gst-master" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"  (click)="toggleMobileMenu()">{{ 'GST Master' | translate }}</a>
                                </li>
                                <li>
                                    <a routerLink="/bh-stamp-duty-master" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"  (click)="toggleMobileMenu()">{{ 'Stamp Duty Master' | translate }}</a>
                                </li>
                                <li>
                                    <a routerLink="/bh-other-charges-master" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"  (click)="toggleMobileMenu()">{{ 'Other Charges Master' | translate }}</a>
                                </li>
                                <li>
                                    <a routerLink="/bh-quote-price-master" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"  (click)="toggleMobileMenu()">{{ 'Quote Price Master' | translate }}</a>
                                </li>
                            </ul>
                        </div>
                    </li>

                    <li class="accordion menu nav-item">
                        <button
                            type="button"
                            class="nav-link group w-full"
                            [ngClass]="{ active: activeDropdown.includes('user-management') }"
                            (click)="toggleAccordion('user-management')"
                        >
                            <div class="flex items-center">
                                <icon-user [fill]="true" class="shrink-0 group-hover:!text-primary" />

                                <span class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark">
                                    {{ 'User Management' | translate }}
                                </span>
                            </div>
                            <div [ngClass]="{ 'rtl:rotate-90 -rotate-90': !activeDropdown.includes('user-management') }">
                                <icon-caret-down />
                            </div>
                        </button>
                        <div [@slideDownUp]="!activeDropdown.includes('user-management')" class="accordion-content text-xs">
                            <ul class="sub-menu text-gray-500">
                                <li>
                                    <a routerLink="/bh-departments" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" (click)="toggleMobileMenu()">{{ 'Departments' | translate }}</a>
                                </li>
                                <li>
                                    <a routerLink="/bh-roles-permissions" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"  (click)="toggleMobileMenu()">{{ 'Roles & Permissions' | translate }}</a>
                                </li>
                                <li>
                                    <a routerLink="/bh-internal-users" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"  (click)="toggleMobileMenu()">{{ 'Internal Users' | translate }}</a>
                                </li>
                            </ul>
                        </div>
                    </li>

                    <li class="accordion menu nav-item">
                        <button
                            type="button"
                            class="nav-link group w-full"
                            [ngClass]="{ active: activeDropdown.includes('rules-and-automations') }"
                            (click)="toggleAccordion('rules-and-automations')"
                        >
                            <div class="flex items-center">
                                <icon-menu-font-icons class="shrink-0 group-hover:!text-primary" />

                                <span class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark">
                                    {{ 'Rules & Automations' | translate }}
                                </span>
                            </div>
                            <div [ngClass]="{ 'rtl:rotate-90 -rotate-90': !activeDropdown.includes('rules-and-automations') }">
                                <icon-caret-down />
                            </div>
                        </button>
                        <div [@slideDownUp]="!activeDropdown.includes('rules-and-automations')" class="accordion-content text-xs">
                            <ul class="sub-menu text-gray-500">
                                <li>
                                    <a routerLink="/bh-approval-rules" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" (click)="toggleMobileMenu()">{{ 'Approval Rules' | translate }}</a>
                                </li>
                                <li>
                                    <a routerLink="/bh-scoring-rules" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"  (click)="toggleMobileMenu()">{{ 'Scoring Rules' | translate }}</a>
                                </li>
                                <li>
                                    <a routerLink="/bh-assignment-rules" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"  (click)="toggleMobileMenu()">{{ 'Assignment Rules' | translate }}</a>
                                </li>
                                <li>
                                    <a routerLink="/bh-stage-locking" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"  (click)="toggleMobileMenu()">{{ 'Stage Locking' | translate }}</a>
                                </li>
                            </ul>
                        </div>
                    </li>

                    <li class="accordion menu nav-item">
                        <button
                            type="button"
                            class="nav-link group w-full"
                            [ngClass]="{ active: activeDropdown.includes('templates-config') }"
                            (click)="toggleAccordion('templates-config')"
                        >
                            <div class="flex items-center">
                                <icon-menu-apps class="shrink-0 group-hover:!text-primary" />

                                <span class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark">
                                    {{ 'Templates Config' | translate }}
                                </span>
                            </div>
                            <div [ngClass]="{ 'rtl:rotate-90 -rotate-90': !activeDropdown.includes('templates-config') }">
                                <icon-caret-down />
                            </div>
                        </button>
                        <div [@slideDownUp]="!activeDropdown.includes('templates-config')" class="accordion-content text-xs">
                            <ul class="sub-menu text-gray-500">
                                <li>
                                    <a routerLink="/bh-email-templates" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" (click)="toggleMobileMenu()">{{ 'Email Templates' | translate }}</a>
                                </li>
                                <li>
                                    <a routerLink="/bh-whatsapp-templates" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"  (click)="toggleMobileMenu()">{{ 'Whatsapp Templates' | translate }}</a>
                                </li>
                                <li>
                                    <a routerLink="/bh-social-media-templates" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"  (click)="toggleMobileMenu()">{{ 'Social Media Templates' | translate }}</a>
                                </li>
                            </ul>
                        </div>
                    </li>

                    <li class="accordion menu nav-item">
                        <button
                            type="button"
                            class="nav-link group w-full"
                            [ngClass]="{ active: activeDropdown.includes('bank-management') }"
                            (click)="toggleAccordion('bank-management')"
                        >
                            <div class="flex items-center">
                                <icon-menu-documentation class="shrink-0 group-hover:!text-primary" />

                                <span class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark">
                                    {{ 'Bank Management' | translate }}
                                </span>
                            </div>
                            <div [ngClass]="{ 'rtl:rotate-90 -rotate-90': !activeDropdown.includes('bank-management') }">
                                <icon-caret-down />
                            </div>
                        </button>
                        <div [@slideDownUp]="!activeDropdown.includes('bank-management')" class="accordion-content text-xs">
                            <ul class="sub-menu text-gray-500">
                                <li>
                                    <a routerLink="/bh-bank-apf" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" (click)="toggleMobileMenu()">{{ 'Bank APF' | translate }}</a>
                                </li>
                                <li>
                                    <a routerLink="/bh-bank-offers" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"  (click)="toggleMobileMenu()">{{ 'Bank Offers' | translate }}</a>
                                </li>
                                <li>
                                    <a routerLink="/bh-fees-charges" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"  (click)="toggleMobileMenu()">{{ 'Fees & Charges' | translate }}</a>
                                </li>
                                <li>
                                    <a routerLink="/bh-existing-loans" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"  (click)="toggleMobileMenu()">{{ 'Existing Loans' | translate }}</a>
                                </li>
                            </ul>
                        </div>
                    </li>

                     <li class="nav-item">
                        <a routerLink="/opportunities" class="group" routerLinkActive="active" (click)="toggleMobileMenu()">
                            <div class="flex items-center">
                                <icon-menu-users class="shrink-0 group-hover:!text-primary" />

                                <span class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark"
                                    >{{ 'Opportunities' | translate }}</span
                                >
                            </div>
                        </a>
                    </li>

                    <li class="nav-item">
                        <a routerLink="/loan-application" class="group" routerLinkActive="active" (click)="toggleMobileMenu()">
                            <div class="flex items-center">
                                <icon-menu-forms class="shrink-0 group-hover:!text-primary" />

                                <span class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark"
                                    >{{ 'Loan Application' | translate }}</span
                                >
                            </div>
                        </a>
                    </li>

                    <li class="nav-item">
                        <a routerLink="/payment-checker" class="group" routerLinkActive="active" (click)="toggleMobileMenu()">
                            <div class="flex items-center">
                                <icon-dollar-sign-circle [fill]="true" class="shrink-0 group-hover:!text-primary" />

                                <span class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark"
                                    >{{ 'Payment Checker' | translate }}</span
                                >
                            </div>
                        </a>
                    </li>

                    <li class="nav-item">
                        <a routerLink="/quality-check-cpa" class="group" routerLinkActive="active" (click)="toggleMobileMenu()">
                            <div class="flex items-center">
                                <icon-menu-authentication class="shrink-0 group-hover:!text-primary" />

                                <span class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark"
                                    >{{ 'Quality Check CPA' | translate }}</span
                                >
                            </div>
                        </a>
                    </li>

                    <li class="nav-item">
                        <a routerLink="/financial-analysis" class="group" routerLinkActive="active" (click)="toggleMobileMenu()">
                            <div class="flex items-center">
                                <icon-menu-charts class="shrink-0 group-hover:!text-primary" />

                                <span class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark"
                                    >{{ 'Financial Analysis' | translate }}</span
                                >
                            </div>
                        </a>
                    </li>

                    <li class="nav-item">
                        <a routerLink="/initiation" class="group" routerLinkActive="active" (click)="toggleMobileMenu()">
                            <div class="flex items-center">
                                <icon-menu-drag-and-drop class="shrink-0 group-hover:!text-primary" />

                                <span class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark"
                                    >{{ 'Initiation' | translate }}</span
                                >
                            </div>
                        </a>
                    </li>

                    <li class="nav-item">
                        <a routerLink="/capturing" class="group" routerLinkActive="active" (click)="toggleMobileMenu()">
                            <div class="flex items-center">
                                <icon-menu-datatables class="shrink-0 group-hover:!text-primary" />

                                <span class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark"
                                    >{{ 'Capturing' | translate }}</span
                                >
                            </div>
                        </a>
                    </li>

                    <li class="nav-item">
                        <a routerLink="/completion" class="group" routerLinkActive="active" (click)="toggleMobileMenu()">
                            <div class="flex items-center">
                                <icon-menu-pages class="shrink-0 group-hover:!text-primary" />

                                <span class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark"
                                    >{{ 'Completion' | translate }}</span
                                >
                            </div>
                        </a>
                    </li>

                    <li class="nav-item">
                        <a routerLink="/underwriter" class="group" routerLinkActive="active" (click)="toggleMobileMenu()">
                            <div class="flex items-center">
                                <icon-menu-forms class="shrink-0 group-hover:!text-primary" />

                                <span class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark"
                                    >{{ 'Underwriter' | translate }}</span
                                >
                            </div>
                        </a>
                    </li>

                    <li class="nav-item">
                        <a routerLink="/post-sanction-cases" class="group" routerLinkActive="active" (click)="toggleMobileMenu()">
                            <div class="flex items-center">
                                <icon-menu-calendar class="shrink-0 group-hover:!text-primary" />

                                <span class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark"
                                    >{{ 'Post Sanction Cases' | translate }}</span
                                >
                            </div>
                        </a>
                    </li>

                    <li class="nav-item">
                        <a routerLink="/amendatory-sanction-cases" class="group" routerLinkActive="active" (click)="toggleMobileMenu()">
                            <div class="flex items-center">
                                <icon-menu-components class="shrink-0 group-hover:!text-primary" />

                                <span class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark"
                                    >{{ 'Amendatory Sanction' | translate }}</span
                                >
                            </div>
                        </a>
                    </li>

                    <li class="nav-item">
                        <a routerLink="/quality-check-operations" class="group" routerLinkActive="active" (click)="toggleMobileMenu()">
                            <div class="flex items-center">
                                <icon-menu-authentication class="shrink-0 group-hover:!text-primary" />

                                <span class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark"
                                    >{{ 'Quality Check Operations' | translate }}</span
                                >
                            </div>
                        </a>
                    </li>

                    <li class="nav-item">
                        <a routerLink="/disbursed-cases" class="group" routerLinkActive="active" (click)="toggleMobileMenu()">
                            <div class="flex items-center">
                                <icon-dollar-sign-circle [fill]="true" class="shrink-0 group-hover:!text-primary" />

                                <span class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark"
                                    >{{ 'Disbursed Cases' | translate }}</span
                                >
                            </div>
                        </a>
                    </li> -->
          </ul>
        </ng-scrollbar>
        <ul class="relative space-y-0.5 p-4 py-0 font-normal">
          <li class="nav-item">
            <a
              [routerLink]="subscriptionMenuLink()"
              class="group"
              [class.active]="isSubscriptionNavActive()"
              (click)="toggleMobileMenu()"
            >
              <div class="flex items-center">
                <icon-crown class="shrink-0 group-hover:!text-primary" />

                <span
                  class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark"
                  >{{ 'Subscription' | translate }}</span
                >
              </div>
            </a>
          </li>
          <li class="nav-item">
            <a
              id="sidebar-whats-new-link"
              routerLink="/changelog"
              class="group"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: false }"
              (click)="toggleMobileMenu()"
            >
              <div class="flex w-full items-center">
                <icon-megaphone class="shrink-0 group-hover:!text-primary" />

                <span
                  class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark"
                  >{{ "What's new" | translate }}</span
                >
                @if (changelogService.hasUnseenRelease()) {
                  <span
                    class="ml-auto inline-block h-2 w-2 shrink-0 rounded-full bg-primary"
                    aria-label="New release"
                  ></span>
                }
              </div>
            </a>
          </li>
          <li class="nav-item">
            <a
              routerLink="/help-center"
              class="group"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: false }"
              (click)="toggleMobileMenu()"
            >
              <div class="flex items-center">
                <icon-help-circle class="shrink-0 group-hover:!text-primary" />

                <span
                  class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark"
                  >{{ 'Help Center' | translate }}</span
                >
              </div>
            </a>
          </li>
          <li class="nav-item">
            <a
              routerLink="/settings"
              class="group"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: false }"
              (click)="toggleMobileMenu()"
            >
              <div class="flex items-center">
                <icon-settings class="shrink-0 group-hover:!text-primary" />

                <span
                  class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark"
                  >{{ 'Settings' | translate }}</span
                >
              </div>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
  <app-create-dashboard-dialog
    [(open)]="showCreateDashboardDialog"
    (created)="loadCustomDashboards()"
  />
</div>
